import { z } from 'zod';
import { EmptyObject } from 'libs/end-to-end/src/generic';
import { createCustomVizRequestSchema } from 'libs/end-to-end/src/custom-viz/createCustomVizRequestSchema';
import { FilterDefinitionForExtras } from 'libs/end-to-end/src/types/databases/filters/filter-definition';
import { FocusArea } from 'libs/end-to-end/src/focus-area';

export const BinScatterMultiSelectExtras = z
  .object({
    filters: z.array(FilterDefinitionForExtras),
    /**
     * columnHeaderValue of the dimension
     */
    dimension: z.string(),
    metric: z.string(),
    focusArea: FocusArea,
  })
  .describe('BinScatterMultiSelectExtras');

export type BinScatterMultiSelectExtras = z.infer<
  typeof BinScatterMultiSelectExtras
>;

export const BinScatterMultiSelectInputs = z.object({
  dropdowns: EmptyObject,
  extras: BinScatterMultiSelectExtras,
});

export const BinScatterMultiSelectRequest = createCustomVizRequestSchema(
  'binScatterMultiSelect',
  BinScatterMultiSelectInputs,
);

export type BinScatterMultiSelectRequest = z.infer<
  typeof BinScatterMultiSelectRequest
>;
